var widgets = require('../lib/widgets');

widgets.create('Field', require('./Field'));
widgets.create('CustomSelect', require('./CustomSelect'));
widgets.create('Form', require('./Form'));
widgets.create('Search', require('./Search'));
widgets.create('Navigation', require('./Navigation'));
widgets.create('SectionNav', require('./SectionNav'));
widgets.create('Equalise', require('./Equalise'));
widgets.create('Slider', require('./Slider'));
widgets.create('DoubleSlider', require('./DoubleSlider'));
widgets.create('GallerySlider', require('./GallerySlider'));
widgets.create('HeroSlider', require('./HeroSlider'));
widgets.create('Quicklinks', require('./Quicklinks'));
widgets.create('Pagination', require('./Pagination'));
widgets.create('AjaxLoader', require('./AjaxLoader'));
widgets.create('Article', require('./Article'));
widgets.create('Print', require('./Print'));
widgets.create('Share', require('./Share'));
widgets.create('ShowHide', require('./ShowHide'));
widgets.create('FakeScroll', require('./FakeScroll'));
widgets.create('LocalTime', require('./LocalTime'));
widgets.create('ViewSwitch', require('./ViewSwitch'));
widgets.create('IconToggle', require('./IconToggle'));
widgets.create('_Map', require('./_Map'));
widgets.create('LocMap', require('./LocMap'));
widgets.create('LocMapMini', require('./LocMapMini'));
widgets.create('Locations', require('./Locations'));
widgets.create('LocDetailsMap', require('./LocDetailsMap'));
widgets.create('GalleryItem', require('./GalleryItem'));
widgets.create('GalleryOverlay', require('./GalleryOverlay'));
widgets.create('FilterToggle', require('./FilterToggle'));
widgets.create('FilterRow', require('./FilterRow'));
widgets.create('Filters', require('./Filters'));
widgets.create('SearchFilters', require('./SearchFilters'));



/*****************
 ** WEBPACK FOOTER
 ** ./source/scripts/widgets/index.js
 ** module id = 8
 ** module chunks = 0 1
 **/